<div class="login-container">
    <mat-card class="login-card">
        <div class="centered">
            <mat-icon>account_circle</mat-icon>
        </div>
        <mat-card-header>
            <mat-card-title>Login</mat-card-title>
            <mat-card-subtitle>Bitte loggen Sie sich ein</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="message alert-danger" *ngIf="invalidLogin">Ungültiger Name und/oder Passwort</div>
            <div class="message alert-danger" *ngIf="loginError">{{ loginError }}</div>
            <form class="form-signin" #f="ngForm" (ngSubmit)="signIn(f.value)">
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="Name" name="name" ngModel>
                </mat-form-field>
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="Passwort" name="password" type="password" ngModel>
                </mat-form-field>
                <button class="full-width" type="submit" mat-flat-button color="primary">Login</button>
            </form>
        </mat-card-content>
    </mat-card>
</div>



